import React from 'react';
import EntryLevelGuideDoc from '../../../assets/guides/EntryLevelGuideDoc.pdf';
import OriginalGuideDoc from '../../../assets/guides/OriginalGuideDoc2.pdf';
import UpgradeGuideDoc from '../../../assets/guides/UpgradeGuideDoc2.pdf';
import RenewalGuideDoc from '../../../assets/guides/RenewalGuideDoc2.pdf';
import {Button} from '@material-ui/core';

const GuideButton = props => {
    const document = props.document;
    const text = props.text;
    return (
        <Button
            href={document}
            target='_blank'
            color='secondary'
            variant='contained'
            style={{
                variant: 'body1',
                fontWeight: 'strong',
                textTransform: 'none',
            }}
        >
            {text}
        </Button>
    );
};

const EntryLevelGuideButton = props => {
    return (
        <GuideButton
            document={EntryLevelGuideDoc}
            text='Open Entry Level MMC Guide'
            {...props}
        />
    );
};

const OriginalGuideButton = props => {
    return (
        <GuideButton
            document={OriginalGuideDoc}
            text='Open Original MMC Guide'
            {...props}
        />
    );
};

const RenewalGuideButton = props => {
    return (
        <GuideButton
            document={RenewalGuideDoc}
            text='Open Renewal Guide'
            {...props}
        />
    );
};

const UpgradeGuideButton = props => {
    return (
        <GuideButton
            document={UpgradeGuideDoc}
            text='Open Upgrade Guide'
            {...props}
        />
    );
};

export {
    EntryLevelGuideButton,
    OriginalGuideButton,
    RenewalGuideButton,
    UpgradeGuideButton,
};
